import http from "../../http-common";
import { Receipt } from '@material-ui/icons';

const get = (data) => http.post("/User/FilterUsers", data);

const saveStockAdjustment = (data) => http.post("/StockAdjustment/SaveStockAdjustment", data);

const getByCodeProduct = (data) => http.post("/ReceiptProduct/GetByCodeProduct", data);

const getByBarCode = (data) => http.post("/ReceiptProduct/GetByBarCode", data);

const getByProductName = (data) => http.post("/ReceiptProduct/GetByProductName", data);


export default { get, getByCodeProduct, getByBarCode, saveStockAdjustment, getByProductName };
